<div class="show-more" [ngClass]="{ 'show-more--mobile-only': mobileOnly }">
  <ng-content></ng-content>
  @if (count > visible) {
    <button class="show-more__button" type="button" [ngStyle]="{ 'margin-left.px': marginLeft }" (click)="toggle()">
      {{ 'globals.' + (active ? 'showLess' : 'showAll') | translate }}
    </button>
  }
</div>
